<template>
  <div class="home" id="home">
    <div class="beta-banner">{{ $t("message.home.betaBannerText") }}</div>
    <EsHeaderView />
    <MainBanner v-if="itemname !== 'Argos' && itemname !== 'INT Overstock'" />
    <MainArgosBanner v-else />
    <MainClassification />
    <!-- <MainSeckill />
    <MainGroup /> -->
    <MainDaily />


    <div
      :class="{ active: downloadShow }"
      :style="{ 'background-image': 'url(' + banner1 + ')' }"
      class="download-content"
      v-if="itemname !== 'TikTok-Wholesale'"
    >
      <div class="download">
        <h3 v-if="itemname !== 'Hive'">
          {{ $t("message.home.homeDownloadtips1") }}
        </h3>
        <h3 v-else>{{ $t("message.home.电商批发商场") }}</h3>
        <h3></h3>
        <div class="tips">
          <div class="item">{{ $t("message.home.homeDownloadtips2") }}</div>
          /
          <div class="item">{{ $t("message.home.homeDownloadtips3") }}</div>
        </div>
        <!-- <div class="btn-content" v-if="itemname !== 'Hive' && itemname !== 'TikTok-Wholesale'">
          <div class="item" @click="downClickA">
            <img :src="android" alt="" />
            <p>{{ $t("message.home.homeDownloadtips4") }}</p>
          </div>
          <div class="item" @click="downClickI">
            <img :src="android" alt="" />
            <p>{{ $t("message.home.homeDownloadtips41") }}</p>
          </div>
        </div> -->
      </div>
    </div>
 
    <MainRecommend @onload="bannerShow = true" />

    <!-- <div  :style="{ 'background-image': 'url(' + banner2 + ')' }" class="banner-content">
      <div class="content">
        <p>{{ $t("message.home.homeBannertips1") }}</p>
        <p>{{ $t("message.home.homeBannertips2") }}</p>
        <h3>{{ $t("message.home.homeBannertips3") }} $200,000</h3>
        <div @click="joinStore">{{ $t("message.home.homeBannerbtn") }}</div>
      </div>
    </div> -->

    

    

    <!-- <div  :style="{ 'background-image': 'url(' + banner2 + ')' }" class="download-content">
      <div class="content">
        <p>{{ $t("message.home.homeBannertips1") }}</p>
        <p>{{ $t("message.home.homeBannertips2") }}</p>
        <h3>{{ $t("message.home.homeBannertips3") }} $200,000</h3>
        <div @click="joinStore">{{ $t("message.home.homeBannerbtn") }}</div>
      </div>
    </div> -->

    <div  :style="{ 'background-image': 'url(' + banner2 + ')' }" class="banner-content">
      <div class="content">
        <p>{{ $t("message.home.homeBannertips1") }}</p>
        <h3>{{ $t("message.home.homeBannertips2") }}</h3>
        <!-- <h3>{{ $t("message.home.homeBannertips3") }} $200,000</h3> -->
        <!-- <div @click="joinStore">{{ $t("message.home.homeBannerbtn") }}</div> -->
      </div>
    </div>

    <!-- <div
      :class="{ active: downloadShow }"
      :style="{ 'background-image': 'url(' + banner2 + ')' }"
      class="download-content"
      v-if="itemname !== 'TikTok-Wholesale'"
    >
      <div class="download">
        <h3 v-if="itemname !== 'Hive'">
          {{ $t("message.home.homeDownloadtips1") }}
        </h3>
        <h3 v-else>{{ $t("message.home.电商批发商场") }}</h3>
        <h3></h3>
        <div class="tips">
          <div class="item">{{ $t("message.home.homeDownloadtips2") }}</div>
          /
          <div class="item">{{ $t("message.home.homeDownloadtips3") }}</div>
        </div>
        <div class="btn-content" v-if="itemname !== 'Hive' && itemname !== 'TikTok-Wholesale'">
          <div class="item" @click="downClickA">
            <img :src="android" alt="" />
            <p>{{ $t("message.home.homeDownloadtips4") }}</p>
          </div>
          <div class="item" @click="downClickI">
            <img :src="android" alt="" />
            <p>{{ $t("message.home.homeDownloadtips41") }}</p>
          </div>
        </div>
      </div>
    </div> -->
    <MainTop @onload="downloadShow = true" />
    <EsIconTips />
    <EsFooterView />
  </div>
</template>

<script>
import config from "@/config/index";
import { mapGetters } from "vuex";
import MainRecommend from "./mainRecommend.vue";
import MainTop from "./mainTop.vue";
import MainBanner from "./mainBanner.vue";
import MainArgosBanner from "./mainBannerArgos.vue";
import MainClassification from "./mainClassification.vue";
import MainDaily from "./mainDaily.vue";
import MainSeckill from "./mainSeckill.vue";
import MainGroup from "./mainGroup.vue";
// import MainRecommendStore from "./mainRecommendStore.vue";
// import VueQr from "vue-qr";

import Axios from "@/util/http";

import EsIconTips from "@/components/iconTips";

import {
  index
} from "@/api/goods/goods.js";
import {
  list
} from "@/api/marketing/seckill_marketing.js";
import {
  group_list
} from "@/api/marketing/group_marketing.js";

export default {
  name: "HomeView",
  components: {
    MainRecommend,
    MainTop,
    MainBanner,
    MainClassification,
    MainDaily,
    // MainSeckill,
    // MainGroup,
    // MainRecommendStore,
    EsIconTips,
    MainArgosBanner,
    // VueQr,
  },
  data() {
    return {
      itemname: process.env.VUE_APP_ITEM_NAME,
      bannerShow: false,
      downloadShow: false,
      banner1: require("@/assets/image/testBanner/index01-En1.jpg"),
        // process.env.VUE_APP_ITEM_NAME == "FamilyShop"
        //   ? require("@/assets/image/familyShop_banner.png") : process.env.VUE_APP_ITEM_NAME == "SM-wholesale shop"
        //     ? require("@/assets/image/SM-1.jpg")
        //     : require("@/assets/image/ads/banner_01.png"),
      // banner2: "https://qiniuio.covebuy.cn/mobile/static/images/banners/index02-En.jpg",
      banner2: require("@/assets/image/testBanner/index02-En1.jpg"),
      android: require("@/assets/image/ads/android01.png"),
      iOS: require("@/assets/image/ads/ios01.png"),
      tipsData: [
        {
          icon: require("@/assets/image/ads/icon_01.png"),
          name: "message.home.homeIconTips1",
        },
        {
          icon: require("@/assets/image/ads/icon_02.png"),
          name: "message.home.homeIconTips2",
        },
        {
          icon: require("@/assets/image/ads/icon_03.png"),
          name: "message.home.homeIconTips3",
        },
        {
          icon: require("@/assets/image/ads/icon_04.png"),
          name: "message.home.homeIconTips4",
        },
      ],
      lang: "",
      top: 0,


      /////////////////////////////////////////////////////////////////////////////////

      messages: [],
      appGlobal: app.globalData,
      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 10,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      objsList: [],
      imgUrls: [],
      autoplay: true,
      circular: true,
      goodsData: [],
      proCat: [],
      thatCount: 0,
      page: 2,
      index: 2,
      brand: [],
      // 滑动
      imgUrl: [],
      kbs: [],
      lastcat: [],
      course: [],
      datas: [],
      keyword: "",
      background: ['demo-text-1', 'demo-text-2', 'demo-text-3'],
      indicatorDots: true,
      vertical: true,
      interval: 2000,
      duration: 500,
      bigTypeCont: 0,
      newslist: [],
      tabTimes: [],
      tabindex: 1,
      classTabs: [],
      classTabsOn: 0,
      topBgcolor: '#8A72E2',
      indexBanner: [{
        src: 'https://qiniuio.covebuy.cn/mobile/static/images/banner1-En.jpg',
        bgcolor: '#8A72E2',
      },
      {
        src: 'https://qiniuio.covebuy.cn/mobile/static/images/banner2-En.jpg',
        bgcolor: '#EE914C',
      },
      {
        src: 'https://qiniuio.covebuy.cn/mobile/static/images/banner3-En.jpg',
        bgcolor: '#4091ff',
      },
        // {
        // 	src: 'https://qiniuio.covebuy.cn/mobile/static/images/banner4-En.jpg',
        // // bgcolor: '#3974e8',
        // 	bgcolor: '#4091ff'
        // }, 
      ],
      loading: false,
      code: {
        src: "/code",
        value: "",
        len: 4,
        type: "image"
      },
      floorsList: [],
      goodsCategorys: [],
      rootGoodsCategories: [],
      selectionGoodss: [], //甄选
      goodsCategorysWidth: 350,
      queryParams: {
        orderType: 'TOP_DESC',
      },
      nowHours: null,
      nowMinutes: null,
      nowSeconds: null,
      hours: 0, //时
      minutes: 59, //分
      seconds: 59, //秒
      countdown: '00:59:59', //倒计时
      timer: null, //重复执行
      //秒杀请求时间场次
      seckillHours: [{
        time: '0:00',
        status: 0,
        hour: 'ZERO',
      }, {
        time: '1:00',
        status: 1,
        hour: 'ONE',
      }, {
        time: '2:00',
        status: 2,
        hour: 'TWO',
      }, {
        time: '3:00',
        status: 3,
        hour: 'THREE',
      }, {
        time: '4:00',
        status: 4,
        hour: 'FOUR',
      }, {
        time: '5:00',
        status: 5,
        hour: 'FIVE',
      }, {
        time: '6:00',
        status: 6,
        hour: 'SIX',
      }, {
        time: '7:00',
        status: 7,
        hour: 'SEVEN',
      }, {
        time: '8:00',
        status: 8,
        hour: 'EIGHT',
      }, {
        time: '9:00',
        status: 9,
        hour: 'NINE',
      }, {
        time: '10:00',
        status: 10,
        hour: 'TEN',
      }, {
        time: '11:00',
        status: 11,
        hour: 'ELEVEN',
      }, {
        time: '12:00',
        status: 12,
        hour: 'TWELVE',
      }, {
        time: '13:00',
        status: 13,
        hour: 'THIRTEEN',
      }, {
        time: '14:00',
        status: 14,
        hour: 'FOURTEEN',
      }, {
        time: '15:00',
        status: 15,
        hour: 'FIFTEEN',
      }, {
        time: '16:00',
        status: 16,
        hour: 'SIXTEEN',
      }, {
        time: '17:00',
        status: 17,
        hour: 'SEVENTEEN',
      }, {
        time: '18:00',
        status: 18,
        hour: 'EIGHTEEN',
      }, {
        time: '19:00',
        status: 19,
        hour: 'NINETEEN',
      }, {
        time: '20:00',
        status: 20,
        hour: 'TWENTY',
      }, {
        time: '21:00',
        status: 21,
        hour: 'TWENTY_ONE',
      }, {
        time: '22:00',
        status: 22,
        hour: 'TWENTY_TWO',
      }, {
        time: '23:00',
        status: 23,
        hour: 'TWENTY_THREE',
      }],
      seckillTags: [],
      //秒杀请求参数
      seckillQueryParams: {
        pageNumber: '1',
        pageSize: '5',
        hour: 'ZERO',
      },
      seckillsList: [], //秒杀
      seckillable: true,
      //拼团
      groupQueryParams: {
        pageNumber: '1',
        pageSize: '5',
      },
      groupsList: [],

      languages: null,
      languagesIdx: 1,


      /////////////////////////////////////////////////////////////////////////////////





    };
  },
  created() {
    this.loadLanguage();
  },
  computed: {
    ...mapGetters({
      downAppUrl: "home/downAppUrl",
      userInfo: "userInfo",
    }),
  },
  mounted() {
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?92294267fcc51d1653e8169034628ff6";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();

    const currentRouter = this.$router.currentRoute;
    if (currentRouter.query.spreadUserId) {
       localStorage.setItem("spreadUserId", currentRouter.query.spreadUserId);
    }

    // window.addEventListener('scroll',this.scrollHandle);//绑定页面滚动事件
    this.lang = localStorage.getItem("BIZ_LANG") || "en";
    // const currentRouter = this.$router.currentRoute;
    if (currentRouter.query.code) {
      localStorage.setItem("agentCode", currentRouter.query.code);
    }

    this.index_floor_goods();
    this.group_list();
    this.seckillInit();


  },
  activated() {
    if (localStorage.getItem("scroll")) {
      document.documentElement.scrollTop = localStorage.getItem("scroll")
    }
    // document.documentElement.scrollTop = this.$route.meta.scrollY



  },
  beforeDestroy() {
    localStorage.setItem('scroll', document.documentElement.scrollTop)
    // window.removeEventListener('scroll', this.scrollHandle)
  },
  methods: {

    loadLanguage() {
      Axios.get("/upms/i18n/message?terminal=admin&language=zh_CN").then(response => {
        // this.loading = false;
        // this.couponList = response.data.data.content;
        // this.total = response.data.data.total;
      }).finally(() => {
        this.loading = false;
      });
    },

    // scrollHandle(e) {
    //    this.top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
    // },
    joinStore() {
      window.open(
        config.HOST_URL +
        "/promote/#/" +
        "?lang=en" +
        "&avatar=" +
        this.userInfo.avatar
      );
    },
    downClickA() {
      if (this.itemname == "Meta") {
        window.open(config.HOST_URL + "/android.apk", "_blank");
      } else if (this.itemname == "Inchoi") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.in.ceapp.go",
          "_blank"
        );
      } else if (this.itemname == 'Shop2u') {
        window.open("https://play.google.com/store/apps/details?id=com.commerce.app", "_blank")
      } else {
        window.open(config.HOST_URL + "/app.html", "_blank");
      }
    },
    downClickI() {
      if (this.itemname == "Meta") {
        window.open(config.HOST_URL + "/IOS.mobileconfig", "_blank");
      } else if (this.itemname == 'Shop2u') {
        window.open("https://apps.apple.com/my/app/shop2u/id6448880380", "_blank")
      } else {
        window.open(config.HOST_URL + "/app.html", "_blank");
      }
    },



    //////////////////////////////////////////////////////////////////////////////////////////


   //秒杀初始化
			seckillInit() {
				let now = new Date();
				let nowHour = now.getHours();
				// let nowHour = 0;
				this.nowHours = nowHour;
				let overHour = (24 - nowHour);
				this.seckillQueryParams.hour = this.seckillHours[nowHour].hour;
				if (this.tabTimes.length < 4) {
					for (let i = 0; i < 4; i++) {
						let timei = {};
						if (i == 0) {
							timei = {
								id: 1 + i,
								time: (nowHour + i) + ':00',
								name: this.messages['shop_seckill_marketing_underway'],
							}
						} else {
							if (nowHour + i < 24) {
								timei = {
									id: 1 + i,
									time: (nowHour + i) + ':00',
									name: this.messages['shop_seckill_marketing_willStart'],
								}
							} else {
								timei = {
									id: 1 + i,
									time: (i - overHour) + ':00',
									name: this.messages['shop_seckill_marketing_willStart'],
								}
							}

						}
						this.tabTimes.push(timei);
					}
				}

				for (let i = 0; i < 4; i++) {
					if ((nowHour + i) < 24) {
						this.seckillTags.push(this.seckillHours[nowHour + i]);
					} else {
						this.seckillTags.push(this.seckillHours[i - overHour]);
					}
				}
				this.minutes = 59 - now.getMinutes();
				this.seconds = 60 - now.getSeconds();
				this.timer = setInterval(() => {
					this.timeCount()
				}, 1000);
				this.seckill_list();
			},
			// 倒计时
			timeCount() {
				--this.seconds;
				if (this.seconds <= 0) {
					--this.minutes;
					this.seconds = 59;
				}
				if (this.minutes <= 0) {
					--this.hours;
					this.minutes = 59
				}
				if (this.hours < 0) {
					this.hours = 0;
					this.seconds = 59;
					this.minutes = 59;
				}
				this.countdown = this.hours + ":" + this.minutes + ":" + this.seconds;
			},

			//枚举转换多语言
			enumToI18n(enumArr, langTitle) {
				// this.types=response.data.data.types;
				let typesI18n = [];
				if (enumArr && enumArr.length > 0) {
					for (let i = 0; i < enumArr.length; i++) {
						let obj = {};
						obj['id'] = i;
						obj['value'] = enumArr[i];
						obj['i18n'] = this.messages[langTitle + '_' + enumArr[i]];
						typesI18n.push(obj);
					}
				}
				return typesI18n;
			},

			// bindLanguagesChange(e) {
			// 	this.languagesIdx = e.detail.value;
			// 	this.languageParams.language = this.languages[e.detail.value].value;
			// 	message(this.languageParams).then(res => {
			// 		if (res.statusCode == '200') {
			// 			let messages = res.data.data.i18n;						
			// 			//这里将语言类型缓存
			// 			uni.setStorageSync("languageShopStorage", JSON.stringify(this.languageParams));
			// 			uni.showToast({
			// 				title: this.messages['common_language_changed'],
			// 				duration: 3000,
			// 				icon: 'none'
			// 			});
			// 			app.removeI18nMessagesStorage();
			// 			app.setI18nMessagesStorage(messages);
			// 			setTimeout(function() {
			// 				uni.reLaunch({
			// 					url: "../../pages/index/index"
			// 				})
			// 			}, 3000);

			// 		} else {
			// 			uni.showToast({
			// 				title: res.data.message,
			// 				duration: 2000
			// 			});
			// 		}
			// 	}).catch(err => {
			// 		console.error(err);
			// 		uni.showToast({
			// 			title: err,
			// 			duration: 2000
			// 		});
			// 	})
			// },


			/**
			 * 秒杀查询列表 list
			 */
			seckill_list() {
        this.loading=true;
				list(this.seckillQueryParams).then(response => {
					this.loading=false;
					//下拉加载
					this.seckillsList = response.data.data;
				});
			},



			/**
			 * 查询列表 list
			 */
			group_list() {
        this.loading=true;
				group_list(this.groupQueryParams).then(response => {
					this.loading=false;
					//下拉加载
					// if (this.loadType === "reach") {
					// 	const newObjsList = response.data.data;
					// 	newObjsList.forEach(item => this.objsList.push(item));
					// 	this.searchLoading = false;
					// 	//加载
					// } else if (this.loadType === "load") {
					this.groupsList = response.data.data;
					//下拉刷新
					// } else if (this.loadType === "pullDown") {
					// 	uni.stopPullDownRefresh();
					// }
				});
			},




			index_floor_goods: function() {
        this.loading=true;
				index(this.queryParams).then(response => {
					this.loading=false;
					this.floorsList = response.data.data.floorGoodss;
					this.rootGoodsCategories = response.data.data.rootGoodsCategories;
					this.selectionGoodss = response.data.data.selectionGoodss;
					this.goodsCategorys = response.data.data.goodsCategorys;
					this.goodsCategorysWidth = 160 * this.goodsCategorys.length;

				});
			},
			onErrorImg(item) {
				this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
				this.$set(item, 'logo', "/static/images/default_thumbnail.jpg");
			},
			switchUser: function() {
				// uni.switchTab({
				// 	url: '../user/user'
				// });
			},
			clickTab: function(e) {
				this.tabindex = e.currentTarget.dataset.id;
				this.seckillable = this.tabindex == 1 ? true : false;
				this.seckillQueryParams.hour = this.seckillTags[this.tabindex - 1].hour;
				this.seckill_list();
			},
			clickShowTab: function(index) {
				this.classTabsOn = index;
				switch (index) {
					case 0: {
						this.queryParams.orderType = "TOP_DESC";
						break;
					}
					case 1: {
						this.queryParams.orderType = "SCORE_DESC";
						break;
					}
					case 2: {
						this.queryParams.orderType = "DATE_DESC";
						break;
					}
					case 3: {
						this.queryParams.orderType = "SALES_DESC";
						break;
					}
					case 4: {
						this.queryParams.orderType = null;
						break;
					}
				}
				this.floorsList = [];
				this.index_floor_goods();

			},
			switchCart: function() {
				// uni.switchTab({
				// 	url: '../cart/cart'
				// });
			},
			swiperchang: function(e) {
				var that = this;
				var bannerIndex = e.detail.current;
				var indexBanner = that.indexBanner;

				for (var i in indexBanner) {
					if (bannerIndex == i) {
						that.topBgcolor = indexBanner[i].bgcolor;
						// uni.setNavigationBarColor({
						// 	frontColor: '#ffffff',
						// 	backgroundColor: indexBanner[i].bgcolor
						// });
					}
				}
			},
			//跳转商品列表页
			listdetail: function(e) {
				uni.navigateTo({
					url: '../category/category_detail?title=' + e.currentTarget.dataset.title,
					success: function(res) { // success
					},
					fail: function() { // fail
					},
					complete: function() { // complete
					}
				});
			},
			keywordChange: function(e) {
				var that = this;
				that.keyword = e.detail.value;
			},
			search_goods: function(e) {
				uni.navigateTo({
					url: '../../goods/goods/search',
					success: function(res) { // success
					},
					fail: function() { // fail
					},
					complete: function() { // complete
					}
				});
			},


    //////////////////////////////////////////////////////////////////////////////////////////






  },
};
</script>

<style lang="scss" scoped>
html[dir="rtl"] {
  .banner-content {
    justify-content: flex-start;
  }

  .download-content {
    justify-content: flex-end;
  }

  .download-content>div.download>.btn-content>.item:nth-child(1) {
    margin-right: 0;
    margin-left: 20px;
  }
}

.beta-banner {
  width: 100%;
  background-color: transparent;
  color: #ff6600;
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.banner-content {
  width: 1200px;
  margin: 0 auto;
  height: 300px;
  overflow: hidden;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-end;

  >.content {
    width: 650px;
    height: 352px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    >p {
      color: #2e2e23;
      font-size: 42px;
    }

    >h3 {
      color: #fa3835;
      font-size: 42px;
    }

    >div {
      padding: 0 40px;
      height: 50px;
      border-radius: 50px;
      line-height: 50px;
      background-color: #2e2e2e;
      color: #f1ce5a;
      font-size: 16px;
      margin-top: 20px;
      cursor: pointer;

      &:hover {
        background-color: #181818;
      }
    }
  }
}

.download-content {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 60px;
  height: 300px;
  overflow: hidden;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // opacity: 0;
  transition: all 0.3s ease;

  &.active {
    opacity: 1;
  }

  >div {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    &.download {
      // margin-left: 72px;
      width: 730px;
      font-weight: bold;
      margin-left: 10px;

      >h3 {
        font-size: 40px;
        letter-spacing: 2px;
        margin-left: 5px;
      }

      >.tips {
        height: 35px;
        line-height: 35px;
        display: flex;
        font-size: 24px;
        margin-top: 10px;

        >.item {
          // width: 100px;
          padding: 0 8px;
        }
      }

      >.btn-content {
        display: flex;
        margin-top: 15px;
        margin-left: 10px;

        >.item {
          // width: 154px;
          height: 37px;
          line-height: 37px;
          background-color: #fff;
          // color: var(--color-main);
          border-radius: 4px;
          border: 1px solid #000;
          display: flex;
          font-size: 14px;
          align-items: center;
          justify-content: center;
          padding: 5px;
          will-change: filter;
          transition: filter 500ms;

          &:nth-child(1) {
            margin-right: 20px;
          }

          &:hover {
            filter: drop-shadow(0 0 4px #333);
          }

          cursor: pointer;

          >img {
            margin-right: 10px;
          }

          p {
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
          }
        }
      }
    }

    &.code-content {
      align-items: center;
      margin-right: 50px;
      padding-top: 20px;

      >.content {
        width: 108px;
        height: 108px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      >p {
        font-size: 14px;
        color: #fff;
        margin-top: 15px;
      }
    }
  }
}

.tips-content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 60px;

  >.item {
    display: flex;
    flex-direction: column;
    align-items: center;

    >p {
      font-size: 12px;
      color: #000;
      margin-top: 15px;
    }
  }
}
</style>
